<template>
  <div>
    <!-- navigator -->
    <b-row v-if="!isEmpty" class="mb-1 hide-mobile">
      <b-col md="6" offset="3">
        <b-row>
          <b-col md="4" v-if="!hideN3">
            <b-card class="text-center">
              <h4
                @click="toN3Details"
                :class="`cursor-pointer ${!selectedN3 && !selectedN2 && !selectedN1 ? 'text-primary' : ''}`"
              >
                {{ $t('Nível 3') }}
              </h4>
            </b-card>
          </b-col>
          <b-col md="4" v-if="!hideN2">
            <b-card class="text-center">
              <h4 @click="backToLeve2" :class="`cursor-pointer ${selectedN3 ? 'text-primary' : ''}`">
                {{ $t('Nível 2') }}
              </h4>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card class="text-center">
              <h4 :class="`cursor-pointer ${selectedN2 ? 'text-primary' : ''}`">{{ $t('Nível 1') }}</h4>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="!isEmpty" class="mb-1 show-only-mobile">
      <b-col md="6">
        <b-row>
          <b-col md="4">
            <b-card class="text-center">
              <h4 :class="`text-primary`">{{ $t(currentLevel) }}</h4>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="!isEmpty">
      <b-col md="4" v-for="(n3, i) in partnersN3" :key="i" class="partner-level-card">
        <b-card class="m-1">
          <b-row>
            <b-col md="8">
              <h5>{{ n3.name }}</h5>
            </b-col>
            <b-col md="4" align="end">
              <div class="btn-group">
                <button
                  class="btn btn-sm btn-primary"
                  @click="showPartnersDetails(n3.partners)"
                  v-b-tooltip.hover
                  :title="$t('Partners')"
                >
                  <i class="fa fa-users" />
                </button>
                <button
                  class="btn btn-sm btn-primary"
                  v-b-tooltip.hover
                  :title="$t('Detail')"
                  @click="toN2Details(n3.id)"
                >
                  <i class="fa fa-list" />
                </button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <small>{{ $t('Turnover') }} </small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n3.turnover) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Payout') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n3.payout) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('GGR') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n3.ggr) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Adm. Fee') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n3.admin_fee) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Liquid Rate') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n3.liquido_rateio) }}</h6>
            </b-col>
            <b-col md="6">
              <small
                >{{ $t('Affiliate Reward') }} <i class="fa fa-info-circle text-secondary" :title="'total'"
              /></small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n3.totalAffiliateReward) }}</h6>
            </b-col>
            <b-col md="6">
              <small
                >{{ $t('Total Reward (n2)') }} <i class="fa fa-info-circle text-secondary" :title="'total'"
              /></small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n3.lowerLevelRewardTotal) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Partners') }}</small>
              <h6 class="text-primary">{{ n3.count_partners }}</h6>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="4" v-for="(n2, i) in partnersN2" :key="i" class="partner-level-card">
        <b-card class="m-1">
          <b-row>
            <b-col md="8">
              <h5>{{ n2.name }}</h5>
            </b-col>
            <b-col md="4" align="end">
              <div class="btn-group">
                <button
                  class="btn btn-sm btn-primary"
                  v-b-tooltip.hover
                  :title="$t('Back')"
                  @click="toN3Details"
                  v-if="!hideN3"
                >
                  <i class="fa fa-arrow-left" />
                </button>
                <button
                  class="btn btn-sm btn-primary"
                  @click="showPartnersDetails(n2.partners)"
                  v-b-tooltip.hover
                  :title="$t('Partners')"
                >
                  <i class="fa fa-users" />
                </button>
                <button
                  class="btn btn-sm btn-primary"
                  v-b-tooltip.hover
                  :title="$t('Detail')"
                  @click="toN1Details(n2.id)"
                >
                  <i class="fa fa-list" />
                </button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <small>{{ $t('Turnover') }} </small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n2.turnover) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Payout') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n2.payout) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('GGR') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n2.ggr) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Adm. Fee') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n2.admin_fee) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Liquid Rate') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n2.liquido_rateio) }}</h6>
            </b-col>
            <b-col md="6">
              <small
                >{{ $t('Affiliate Reward') }} <i class="fa fa-info-circle text-secondary" :title="'total'"
              /></small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n2.totalAffiliateReward) }}</h6>
            </b-col>
            <b-col md="6">
              <small
                >{{ $t('Total Reward (n1)') }} <i class="fa fa-info-circle text-secondary" :title="'total'"
              /></small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n2.lowerLevelRewardTotal) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Partners') }}</small>
              <h6 class="text-primary">{{ n2.count_partners }}</h6>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="4" v-for="(n1, i) in partnersN1" :key="i" class="partner-level-card">
        <b-card class="m-1">
          <b-row>
            <b-col md="8">
              <h5>{{ n1.name }}</h5>
            </b-col>
            <b-col md="4" align="end">
              <div class="btn-group">
                <button
                  class="btn btn-sm btn-primary"
                  v-b-tooltip.hover
                  :title="$t('Back')"
                  @click="backToLeve2"
                  v-if="!hideN2"
                >
                  <i class="fa fa-arrow-left" />
                </button>
                <button
                  class="btn btn-sm btn-primary"
                  @click="showPartnersDetails(n1.partners, n1)"
                  v-b-tooltip.hover
                  :title="$t('Partners')"
                >
                  <i class="fa fa-users" />
                </button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <small>{{ $t('Turnover') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n1.turnover) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Payout') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n1.payout) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('GGR') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n1.ggr) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Adm. Fee') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n1.admin_fee) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Liquid Rate') }}</small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n1.liquido_rateio) }}</h6>
            </b-col>
            <b-col md="6">
              <small
                >{{ $t('Affiliate Reward') }} <i class="fa fa-info-circle text-secondary" :title="'total'"
              /></small>
              <h6 class="text-primary">{{ $utils.formatMoneyFloat(n1.totalAffiliateReward) }}</h6>
            </b-col>
            <b-col md="6">
              <small>{{ $t('Partners') }}</small>
              <h6 class="text-primary">{{ n1.count_partners }}</h6>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-modal v-model="partnersDetails" :title="`${$t('Partners')} - ${$t(currentLevel)}`" hide-footer>
        <div>
          <b-row v-for="(p, i) in partners" :key="i">
            <b-col>
              <b-card>
                <b-row>
                  <b-col>
                    <b>{{ $t('Name') }}</b
                    >: {{ p.detail.name }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b>{{ $t('Reward') }}</b
                    >:
                    {{ $utils.formatMoneyFloat(parseFloat(p.reward)) }}
                    <i
                      class="text-secondary mdi mdi-information"
                      :title="`${$t('Calculation')}`"
                      v-b-popover.hover="$utils.partnerCalculation"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b>{{ $t('Percentage') }}</b
                    >: {{ $utils.formatPercent(p.detail.reward.percentage * 100) }}
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col align="end">
              <button
                v-if="selectedN2"
                class="btn btn-sm btn-primary"
                v-b-tooltip.hover
                :title="$t('Affiliates')"
                @click="showN1Affiliates()"
              >
                {{ $t('Affiliates') }}
              </button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </b-row>
    <b-row v-if="!isEmpty">
      <b-col class="text-right">
        <small
          >{{ $t('Showing') }}: <b>{{ currentLevel }}</b></small
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ['dataset', 'affiliatesDataset', 'n2Filter', 'n3Filter'],
  emits: ['showAffiliates', 'setSelectedN2'],
  data() {
    return {
      partnersDetails: false,
      partners: [],
      selectedN3: null,
      selectedN2: null,
      selectedN1: null,
      n1Filter: null,
      n3Bkp: null
    };
  },
  created() {
    if (this.$store?.state?.partnerAccess?.level) {
      this.$nextTick(() => {
        this.filterPartnerLevel();
      });
    }
  },
  computed: {
    isEmpty() {
      return (
        !this.dataset?.partnersRewards?.partnersN3?.length ||
        !this.dataset?.partnersRewards?.partnersN2?.length ||
        !this.dataset?.partnersRewards?.partnersN1?.length
      );
    },
    partnersN3() {
      if (this.selectedN3 || this.selectedN2 || this.selectedN1) return [];
      let partnersN3 = this?.dataset?.partnersRewards?.partnersN3 || [];
      return partnersN3.map((n3) => {
        let affiliates = this.dataset.affiliateEntries.filter((a) => a.pl3_id == n3.id);
        let pObj = {
          ...n3,
          turnover: affiliates.reduce((a, p) => a + parseFloat(p?.turnover || 0), 0),
          payout: affiliates.reduce((a, p) => a + parseFloat(p?.payout || 0), 0),
          ggr: affiliates.reduce((a, p) => a + parseFloat(p?.ggr || 0), 0),
          admin_fee: affiliates.reduce((a, p) => a + parseFloat(p?.admin_fee || 0), 0),
          liquid_rate: affiliates.reduce((a, p) => a + parseFloat(p?.reward_accumulative || 0), 0),
          count_partners: n3?.partners?.length || 0
        };

        pObj['liquido_rateio'] = pObj.ggr - pObj.admin_fee - pObj.liquid_rate;

        return pObj;
      });
    },
    partnersN2() {
      if (!this.selectedN3) return [];

      let partnersN2 = this?.dataset?.partnersRewards?.partnersN2 || [];
      return partnersN2
        .filter((n2) => {
          return n2.parentLevel == this.selectedN3;
        })
        .map((n2) => {
          let affiliates = this.dataset.affiliateEntries.filter((a) => a.pl2_id == n2.id);
          let pObj = {
            ...n2,
            turnover: affiliates.reduce((a, p) => a + parseFloat(p?.turnover || 0), 0),
            payout: affiliates.reduce((a, p) => a + parseFloat(p?.payout || 0), 0),
            ggr: affiliates.reduce((a, p) => a + parseFloat(p?.ggr || 0), 0),
            admin_fee: affiliates.reduce((a, p) => a + parseFloat(p?.admin_fee || 0), 0),
            liquid_rate: affiliates.reduce((a, p) => a + parseFloat(p?.reward_accumulative || 0), 0),
            count_partners: n2?.partners?.length || 0
          };

          pObj['liquido_rateio'] = pObj.ggr - pObj.admin_fee - pObj.liquid_rate;

          return pObj;
        });
    },
    partnersN1() {
      if (!this.selectedN2) return [];

      let partnersN1 = this?.dataset?.partnersRewards?.partnersN1 || [];
      return partnersN1
        .filter((n1) => {
          return n1.parentLevel == this.selectedN2;
        })
        .map((n1) => {
          let affiliates = this.dataset.affiliateEntries.filter((a) => a.pl1_id == n1.id);
          let pObj = {
            ...n1,
            turnover: affiliates.reduce((a, p) => a + parseFloat(p?.turnover || 0), 0),
            payout: affiliates.reduce((a, p) => a + parseFloat(p?.payout || 0), 0),
            ggr: affiliates.reduce((a, p) => a + parseFloat(p?.ggr || 0), 0),
            admin_fee: affiliates.reduce((a, p) => a + parseFloat(p?.admin_fee || 0), 0),
            liquid_rate: affiliates.reduce((a, p) => a + parseFloat(p?.reward_accumulative || 0), 0),
            count_partners: n1?.partners?.length || 0
          };

          pObj['liquido_rateio'] = pObj.ggr - pObj.admin_fee - pObj.liquid_rate;

          return pObj;
        });
    },
    currentLevel() {
      let level = 'Level 3';

      if (this.selectedN3) {
        level = 'Level 2';
      }
      if (this.selectedN2) {
        level = 'Level 1';
      }

      return level;
    },
    loggedPartner() {
      if (this.$store?.state?.partnerAccess?.level) {
        return this.$utils.getObjectRaw(this.$store?.state?.partnerAccess);
      }

      return {};
    },
    hideN2() {
      if (this.loggedPartner?.level == 1) {
        return true;
      }
      return false;
    },
    hideN3() {
      if (this.loggedPartner?.level == 2 || this.loggedPartner?.level == 1) {
        return true;
      }
      return false;
    }
  },
  methods: {
    filterPartnerLevel() {
      let partner = this.$utils.getObjectRaw(this.$store?.state?.partnerAccess);
      let n3 = null;
      let n2 = null;
      let n1 = null;

      try {
        switch (partner.level) {
          case 1:
            n3 = this.partnersN3[0];
            this.toN2Details(n3.id);

            this.$nextTick(() => {
              n2 = this.partnersN2[0];
              this.toN1Details(n2.id);

              this.$nextTick(() => {
                n1 = this.partnersN1[0];
                this.n1Filter = n1.id;
              });
            });
            break;
          case 2:
            n3 = this.partnersN3[0];
            this.toN2Details(n3.id);
            break;
        }
      } catch (error) {
        console.log(error);
      }
    },
    backToLeve2() {
      if (!this.n3Bkp) return;

      this.toN2Details(this.n3Bkp);
    },
    showN1Affiliates() {
      this.partnersDetails = false;
      this.$nextTick(() => {
        this.$emit('showAffiliates', this.n1Filter);
      });
    },
    showPartnersDetails(partners = [], n1 = null) {
      this.partnersDetails = true;
      this.n1Filter = n1;

      // Comissionado logado não pode ver comissão de outros do mesmo nível
      try {
        if (this.loggedPartner?.id) {
          let partnerIdx = partners.findIndex((p) => {
            return p?.id == this.loggedPartner?.id;
          });

          if (partnerIdx >= 0) {
            partners = [partners[partnerIdx]];
          }
        }
      } catch (error) {
        console.log(error);
      }

      this.partners = partners;
    },
    toN3Details() {
      this.selectedN3 = null;
      this.selectedN2 = null;
      this.selectedN1 = null;
    },
    toN2Details(n3) {
      this.n3Bkp = n3;
      this.selectedN3 = n3;
      this.selectedN2 = null;
      this.selectedN1 = null;
    },
    toN1Details(n2) {
      this.selectedN3 = null;
      this.selectedN2 = n2;
      this.selectedN1 = null;

      this.$emit('setSelectedN2', n2);
      this.$emit('setSelectedN3', this.n3Bkp);
    },
    toAffiliateDetails(n1) {
      this.selectedN3 = null;
      this.selectedN2 = null;
      this.selectedN1 = n1;
    }
  },
  mounted() {
    if (this.n2Filter) {
      this.toN1Details(this.n2Filter);
      this.n3Bkp = this.n3Filter;
      this.$emit('setSelectedN2', null);
    }
  }
};
</script>

<style lang="scss">
.partner-level-card {
  min-width: none !important;
}
@media (min-width: 600px) {
  .partner-level-card {
    min-width: 350px !important;
  }
}
.popover {
  z-index: 1060;
}
</style>
